import { generateId } from '../lib/lib';

const API = 'https://www.youtube.com/iframe_api';
let players = [];

const onPlayerReady = event => {
  event.target.playVideo();
};

const loadAPI = () => {
  if (typeof YT == 'undefined' || typeof YT.Player == 'undefined') {
    var tag = document.createElement('script');
    tag.src = API;
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

    return false;
  } else {
    return true;
  }
};

const loadVideo = (videoId, playerElement) => {
  var player = new YT.Player(playerElement, {
    height: '390',
    width: '640',
    videoId: videoId,

    events: {
      onReady: onPlayerReady,
    },
  });

  players.push(player);
};

const handleLoadVideo = (id, element) => {
  const playerElement = element.querySelector('.js-video__player');
  playerElement.setAttribute('id', generateId(element, 'player-'));

  loadAPI()
    ? loadVideo(id, playerElement)
    : (window.onYouTubePlayerAPIReady = () => {
        loadVideo(id, playerElement);
      });
};

export const video = selector => {
  const videoContainers = [...document.querySelectorAll(selector)];

  if (videoContainers.length) {
    var body = document.querySelector('body');
    body.addEventListener('click', event => {
      const element = event.target.closest(selector);
      if (!element) return;

      const id = element.dataset.videoId;

      if (!id) return;

      const playButton = element.querySelector('.c-video__play');
      playButton ? playButton.classList.add('d-none') : null;
      handleLoadVideo(id, element);
    });
  }
};
